// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router'
import '@/assets/static/css/main.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import store from './store'
// 全局引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// import './assets/css/bootstrap.min.css';
Vue.config.productionTip = false
import './assets/icon/iconfont.css'
/* eslint-disable no-new */
import "babel-polyfill";

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js